import clsx from 'clsx';

interface ITagCapsuleProps {
  value: string | number;
  className?: string;
}

export const TagCapsule = ({ value, className }: ITagCapsuleProps) => (
  <span
    className={clsx(
      'px-2 py-0.5 rounded-full text-xs font-semibold inline-flex items-center',
      className
    )}
  >
    {value}
  </span>
);

export default TagCapsule;
